import {BreadCrumbs} from "../../../components/open/pages";
import {
    ThinArrowLeft,
    ThinChevronRight,
    ThinCreditScoreIcon, ThinHistoryIcon,
    ThinnerPeopleIcon, ThinnerSMSIcon,
    ThinTaskIcon,
    ThinTimeIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {useEffect, useState} from "react";
import {AdminFinanceGroupContractModal} from "./group-contract-modal";
import {AdminFinanceGroupPaymentModal} from "./group-payment-modal";
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    defaults,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from "chart.js";
import {Line} from "react-chartjs-2";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {Link, useNavigate} from "react-router-dom";
import '../../../static/css/pages/finance.css';
import {AdminFinanceGroupReminderModal} from "./group-reminder-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";

defaults.font.family = 'estedad';
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
);

export const AdminFinanceScreen = () => {
    const [groupSign, setGroupSign] = useState(false);
    const [groupPayment, setGroupPayment] = useState(false);
    const [data, setData] = useState({
        loaded: false,
        totalTuitionPaid: 0,
        countTuitionPayments: 0,
        totalTuitionLeft: 0,
        countWhoOweTuition: 0,
        countStudents: 0,
        postedTime: {from: null, to: null} as DayRange,
        reminders:0,
        canLogs:false,
        canTuition:false,
        canReminders:false,
    });
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const [revenueChart, setRevenueChart] = useState({
        store: [] as number[],
        labels: [] as string[],
        tuition: [] as number[],
    });
    const navigate = useNavigate();
    const fetchData = (t: DayRange) => {
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            if ('fa' === 'fa') {
                const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
                const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
                fromString = g;
                toString = g2;
            } else {
                fromString = `${t.from.year}-${t.from.month < 10 ? `0${t.from.month}` : t.from.month}-${t.from.day < 10 ? `0${t.from.day}` : t.from.day}`;
                toString = `${t.to.year}-${t.to.month < 10 ? `0${t.to.month}` : t.to.month}-${t.to.day < 10 ? `0${t.to.day}` : t.to.day}`;
            }
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            if ('fa' === 'fa') {
                const g1 = GregorianToPersian(priorDate).split('-');
                from = {
                    year: parseInt(g1[0]),
                    month: parseInt(g1[1]),
                    day: parseInt(g1[2]),
                };
                const g2 = GregorianToPersian(today).split('-');
                to = {
                    year: parseInt(g2[0]),
                    month: parseInt(g2[1]),
                    day: parseInt(g2[2]),
                };
            }
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            let g2 = `${to.year}-${toMonth}-${toDay}`;
            if ('fa' === 'fa') {
                g = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
                g2 = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            }
            fromString = g;
            toString = g2;
            setTime({
                from: from,
                to: to,
            });
        }
        setData(v => {
            let x = {...v};
            x.loaded = false;
            return x;
        });
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/admins/finance/overview",
            {
                f: fromString,
                t: toString,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                totalTuitionPaid: number,
                countTuitionPayments: number,
                totalTuitionLeft: number,
                countWhoOweTuition: number,
                countStudents: number,
                tuition: {
                    day: string,
                    total: number,
                }[],
                store: {
                    day: string,
                    total: number,
                }[],
                reminders:number,
                canLogs:boolean,
                canReminders:boolean,
                canTuition:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }

                let tuitionChart = [] as number[];
                let chartLabels = [] as string[];
                let storeChart = [] as number[];
                d.tuition.forEach(t => {
                    chartLabels.push(StringDigitsConvertToPersian(GregorianToPersian(t.day)).replaceAll('-', '/'));
                    tuitionChart.push(t.total);
                });
                d.store.forEach(t => {
                    storeChart.push(t.total);
                });
                setRevenueChart({
                    labels: chartLabels,
                    store: storeChart,
                    tuition: tuitionChart,
                });

                const fromArr = fromString.split('-');
                const toArr = toString.split('-');
                setData({
                    loaded: true,
                    postedTime: {
                        from: {
                            year: parseInt(fromArr[0]),
                            month: parseInt(fromArr[1]),
                            day: parseInt(fromArr[2]),
                        },
                        to: {
                            year: parseInt(toArr[0]),
                            month: parseInt(toArr[1]),
                            day: parseInt(toArr[2]),
                        },
                    },
                    countStudents: d.countStudents,
                    countTuitionPayments: d.countTuitionPayments,
                    countWhoOweTuition: d.countWhoOweTuition,
                    totalTuitionLeft: d.totalTuitionLeft,
                    totalTuitionPaid: d.totalTuitionPaid,
                    reminders: d.reminders,
                    canLogs: d.canLogs,
                    canReminders: d.canReminders,
                    canTuition: d.canTuition,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void (0));
    };
    useEffect(() => {
        document.title = "امور مالی | نهال";
        fetchData({from: null, to: null});
    }, []);
    const [reminderModal, setReminderModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
            ]}/>
            <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                <div className="d-flex justify-content-between align-items-center"
                     style={{padding: '30px 15px 5px 15px'}}>
                    <h1 className="page-title" style={{margin: 0}}>
                        امور مالی
                        <span className="f-roboto">آمار و نمودار های مربوط به درآمد شهریه مدرسه.</span>
                    </h1>
                </div>
                <div className="row acc-analytics" style={{marginTop: 20}}>
                    <div className="col-lg-8">
                        <div className="dashboard--chart" style={{marginTop: 0}}>
                            <b>نمودار درآمد در بازه زمانی</b>
                            <Line data={{
                                labels: revenueChart.labels,
                                datasets: [
                                    {
                                        label: 'شهریه',
                                        data: revenueChart.tuition,
                                        borderColor: 'rgb(0, 100, 255,0.4)',
                                        backgroundColor: 'rgba(0,100,255, 0.5)',
                                    },
                                    // {
                                    //     label: 'فروشگاه',
                                    //     data: revenueChart.store,
                                    //     borderColor: 'rgb(0, 100, 255,0.4)',
                                    //     backgroundColor: 'rgba(0,100,255, 0.5)',
                                    // },
                                ],
                            }}/>
                        </div>
                        <div className="row">
                            {
                                data.loaded ?
                                    <>
                                        <div className="col-12">
                                            <b className={"acc-analytics-card-section"}>آمار مالی شهریه</b>
                                        </div>
                                        <AnalyticsCard
                                            value={data.totalTuitionPaid.toString()}
                                            isMoney={true}
                                            icon={<ThinCreditScoreIcon/>}
                                            text={"شهریه پرداخت شده"}
                                            onClick={"/admins/finance/tuition"}
                                        />
                                        <AnalyticsCard
                                            value={data.totalTuitionLeft.toString()}
                                            isMoney={true}
                                            icon={<ThinTimeIcon/>}
                                            text={"شهریه بدهی"}
                                            onClick={null}
                                        />
                                        <AnalyticsCard
                                            value={CurrencyFormat(data.countStudents - data.countWhoOweTuition)}
                                            isMoney={false}
                                            icon={<ThinnerPeopleIcon/>}
                                            text={"دانش‌آموزان تسویه‌حساب شده"}
                                            onClick={"/admins/finance/paid-full"}
                                        />
                                        <AnalyticsCard
                                            value={CurrencyFormat(data.countWhoOweTuition)}
                                            isMoney={false}
                                            icon={<ThinnerPeopleIcon/>}
                                            text={"دانش‌آموزان بدهکار"}
                                            onClick={"/admins/finance/still-owe"}
                                        />
                                        <AnalyticsCard
                                            value={CurrencyFormat(data.countTuitionPayments)}
                                            isMoney={false}
                                            icon={<ThinCreditScoreIcon/>}
                                            text={"تعداد پرداخت آنلاین شهریه"}
                                            onClick={"/admins/finance/tuition/online"}
                                        />
                                        {
                                            data.canReminders ?
                                                <AnalyticsCard
                                                    value={CurrencyFormat(data.reminders)}
                                                    isMoney={false}
                                                    icon={<ThinnerSMSIcon/>}
                                                    text={"یادآوری‌های درانتظار"}
                                                    onClick={"/admins/finance/reminders"}
                                                /> : null
                                        }
                                        {/*<div className="col-12">*/}
                                        {/*    <hr style={{margin: '0 0 20px 0'}}/>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-12">*/}
                                        {/*    <b className={"acc-analytics-card-section"}>بوفه</b>*/}
                                        {/*</div>*/}
                                        {/*<AnalyticsCard*/}
                                        {/*    value={data.totalBalance.toString()}*/}
                                        {/*    isMoney={true}*/}
                                        {/*    icon={<ThinAccountBalanceIcon/>}*/}
                                        {/*    text={"کل موجودی بوفه"}*/}
                                        {/*    onClick={null}*/}
                                        {/*/>*/}
                                        {/*<AnalyticsCard*/}
                                        {/*    value={CurrencyFormat(data.totalHavingMoney)}*/}
                                        {/*    isMoney={false}*/}
                                        {/*    icon={<ThinnerPeopleIcon/>}*/}
                                        {/*    text={"افراد دارای موجودی بوفه"}*/}
                                        {/*    onClick={null}*/}
                                        {/*/>*/}
                                        {/*<AnalyticsCard*/}
                                        {/*    value={data.totalStorePositive.toString()}*/}
                                        {/*    isMoney={true}*/}
                                        {/*    icon={<ThinStoreIcon/>}*/}
                                        {/*    text={"فروش بوفه"}*/}
                                        {/*    onClick={null}*/}
                                        {/*/>*/}
                                        {/*<AnalyticsCard*/}
                                        {/*    value={CurrencyFormat(data.totalSaleCount)}*/}
                                        {/*    isMoney={false}*/}
                                        {/*    icon={<ThinStoreIcon/>}*/}
                                        {/*    text={"تعداد تراکنش‌های خرید بوفه"}*/}
                                        {/*    onClick={null}*/}
                                        {/*/>*/}
                                    </> : null
                            }
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <label className="f-roboto">
                            بازه زمانی مدنظرتان را انتخاب کنید:
                        </label>
                        <Calendar
                            value={time}
                            onChange={e => {
                                const d = {...data};
                                setTime(e);
                                if (e.from !== null && e.to !== null && d.postedTime.from !== e.from && d.postedTime.to !== e.to)
                                    fetchData(e);
                            }}
                            shouldHighlightWeekends
                            colorPrimary='#0a53be'
                            locale={'fa'}
                        />
                        <label className="f-roboto" style={{marginTop: 10}}>
                            همچنین می‌توانید از فهرست زیر انتخاب کنید:
                        </label>
                        <button className="acc-analytics-time-btn f-roboto" onClick={() => {
                            let today;
                            if ('fa' === 'fa')
                                today = GregorianToPersian(new Date()).split('-');
                            else
                                today = new Date().toISOString().split('T')[0].split('-');
                            const v = {
                                year: parseInt(today[0]),
                                month: parseInt(today[1]),
                                day: parseInt(today[2]),
                            };
                            setTime({from: v, to: v});
                            fetchData({from: v, to: v});
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>
                            <ThinTimeIcon/>
                            <span>امروز</span>
                        </button>
                        <button className="acc-analytics-time-btn f-roboto" onClick={() => {
                            let today;
                            if ('fa' === 'fa')
                                today = GregorianToPersian(new Date()).split('-');
                            else
                                today = new Date().toISOString().split('T')[0].split('-');

                            const to = {
                                year: parseInt(today[0]),
                                month: parseInt(today[1]),
                                day: parseInt(today[2]),
                            };
                            const from = {
                                year: to.year,
                                month: to.month,
                                day: 1,
                            };
                            setTime({from: from, to: to});
                            fetchData({from: from, to: to});
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>
                            <ThinTimeIcon/>
                            <span>این ماه</span>
                        </button>
                        <button className="acc-analytics-time-btn f-roboto" onClick={() => {
                            let today;
                            if ('fa' === 'fa')
                                today = GregorianToPersian(new Date()).split('-');
                            else
                                today = new Date().toISOString().split('T')[0].split('-');
                            let m = parseInt(today[1]);
                            let y = parseInt(today[0]);
                            const to = {
                                year: y,
                                month: m,
                                day: 1,
                            };
                            if (m === 1) {
                                y--;
                                m = 12;
                            } else {
                                m--;
                            }
                            const from = {
                                year: y,
                                month: m,
                                day: 1,
                            };
                            setTime({from: from, to: to});
                            fetchData({from: from, to: to});
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>
                            <ThinTimeIcon/>
                            <span>ماه گذشته</span>
                        </button>
                        <button className="acc-analytics-time-btn f-roboto d-none" onClick={() => {
                            const today = new Date();
                            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
                            const todayIso = today.toISOString().split('T')[0].split('-');
                            const priorIso = priorDate.toISOString().split('T')[0].split('-');
                            let from = {
                                year: parseInt(priorIso[0]),
                                month: parseInt(priorIso[1]),
                                day: parseInt(priorIso[2]),
                            };
                            let to = {
                                year: parseInt(todayIso[0]),
                                month: parseInt(todayIso[1]),
                                day: parseInt(todayIso[2]),
                            };
                            const g1 = GregorianToPersian(priorDate).split('-');
                            from = {
                                year: parseInt(g1[0]),
                                month: parseInt(g1[1]),
                                day: parseInt(g1[2]),
                            };
                            const g2 = GregorianToPersian(today).split('-');
                            to = {
                                year: parseInt(g2[0]),
                                month: parseInt(g2[1]),
                                day: parseInt(g2[2]),
                            };
                            setTime({
                                from: from,
                                to: to,
                            });
                            fetchData({from: from, to: to});
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>
                            <ThinTimeIcon/>
                            <span>۳۰ روز گذشته</span>
                        </button>
                        <button className="acc-analytics-time-btn f-roboto d-none" onClick={() => {
                            const today = new Date();
                            const priorDate = new Date(new Date().setDate(today.getDate() - (30 * 3)));
                            const todayIso = today.toISOString().split('T')[0].split('-');
                            const priorIso = priorDate.toISOString().split('T')[0].split('-');
                            let from = {
                                year: parseInt(priorIso[0]),
                                month: parseInt(priorIso[1]),
                                day: parseInt(priorIso[2]),
                            };
                            let to = {
                                year: parseInt(todayIso[0]),
                                month: parseInt(todayIso[1]),
                                day: parseInt(todayIso[2]),
                            };
                            if ('fa' === 'fa') {
                                const g1 = GregorianToPersian(priorDate).split('-');
                                from = {
                                    year: parseInt(g1[0]),
                                    month: parseInt(g1[1]),
                                    day: parseInt(g1[2]),
                                };
                                const g2 = GregorianToPersian(today).split('-');
                                to = {
                                    year: parseInt(g2[0]),
                                    month: parseInt(g2[1]),
                                    day: parseInt(g2[2]),
                                };
                            }
                            setTime({from: from, to: to});
                            fetchData({from: from, to: to});
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>
                            <ThinTimeIcon/>
                            <span>۹۰ روز گذشته</span>
                        </button>
                        <button className="acc-analytics-time-btn f-roboto" onClick={() => {
                            let today;
                            if ('fa' === 'fa')
                                today = GregorianToPersian(new Date()).split('-');
                            else
                                today = new Date().toISOString().split('T')[0].split('-');

                            const to = {
                                year: parseInt(today[0]),
                                month: parseInt(today[1]),
                                day: parseInt(today[2]),
                            };
                            const from = {
                                year: to.year,
                                month: 1,
                                day: 1,
                            };
                            setTime({from: from, to: to});
                            fetchData({from: from, to: to});
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>
                            <ThinTimeIcon/>
                            <span>امسال</span>
                        </button>
                        <hr/>
                        <div className="screen-card">
                            {
                                data.canTuition || data.canReminders ?
                                    <div className="screen-card-header">
                                        <b>امکانات گروهی</b>
                                    </div> : null
                            }
                            {
                                data.canTuition ?
                                    <>
                                        <button className="normal-list-tile" onClick={() => setGroupSign(true)}>
                                            <div>
                                                <i><ThinTaskIcon/></i>
                                                <div>
                                                    <b>تنظیم قرارداد گروهی</b>
                                                    {/*<span>قرارداد شهریه گروهی از دانش‌آموزان را تنظیم کنید.</span>*/}
                                                </div>
                                            </div>
                                            <ThinChevronRight/>
                                        </button>
                                        <button className="normal-list-tile" onClick={() => setGroupPayment(true)}>
                                            <div>
                                                <i><ThinCreditScoreIcon/></i>
                                                <div>
                                                    <b>ثبت شهریه گروهی</b>
                                                    {/*<span>یک رکورد پرداخت شهریه برای گروهی از دانش‌آموزان ثبت کنید.</span>*/}
                                                </div>
                                            </div>
                                            <ThinChevronRight/>
                                        </button>
                                    </> : null
                            }
                            {
                                data.canReminders ?
                                    <button className="normal-list-tile" onClick={() => setReminderModal(true)}>
                                        <div>
                                            <i><ThinnerSMSIcon/></i>
                                            <div>
                                                <b>ثبت یادآوری گروهی</b>
                                                {/*<span>یک رکورد پرداخت شهریه برای گروهی از دانش‌آموزان ثبت کنید.</span>*/}
                                            </div>
                                        </div>
                                        <ThinChevronRight/>
                                    </button> : null
                            }
                            {
                                data.canLogs ?
                                    <>
                                        <hr/>
                                        <div className="screen-card-header">
                                            <b>گزارشات کاربردی</b>
                                        </div>
                                        <Link to={"/admins/finance/logs"} className="normal-list-tile">
                                            <div>
                                                <i><ThinHistoryIcon/></i>
                                                <div>
                                                    <b>سابقه عملیات مالی</b>
                                                </div>
                                            </div>
                                            <ThinChevronRight/>
                                        </Link>
                                    </> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <AdminFinanceGroupContractModal
                active={groupSign}
                closeHandler={() => setGroupSign(false)}
            />
            <AdminFinanceGroupPaymentModal
                active={groupPayment}
                closeHandler={() => setGroupPayment(false)}
            />
            <AdminFinanceGroupReminderModal
                active={reminderModal}
                closeHandler={() => setReminderModal(false)}
            />
        </>
    );
};

const AnalyticsCard = (props: {
    text: string,
    value: string,
    isMoney: boolean,
    icon: JSX.Element,
    onClick: string | null
}) => {
    return (
        <div className="col-md-6">
            {
                props.onClick === null ?
                    <div className="acc-analytics-card">
                        <em>{props.icon}</em>
                        <div>
                            <b>{props.text}</b>
                            <span className="f-roboto">
                    {
                        props.isMoney ?
                            <>
                                {parseInt(props.value) < 0 && 'fa' !== 'fa' ? '-' : ''}
                                {CurrencyFormat(props.value.replace('-', ''))}
                                {parseInt(props.value) < 0 && 'fa' === 'fa' ? '-' : ''}
                                <TomansIcon/>
                            </> :
                            props.value
                    }
                </span>
                        </div>
                    </div> :
                    <Link to={props.onClick} className="acc-analytics-card">
                        <strong>
                            <ThinArrowLeft/>
                        </strong>
                        <em>{props.icon}</em>
                        <div>
                            <b>{props.text}</b>
                            <span className="f-roboto">
                    {
                        props.isMoney ?
                            <>
                                {parseInt(props.value) < 0 && 'fa' !== 'fa' ? '-' : ''}
                                {CurrencyFormat(props.value.replace('-', ''))}
                                {parseInt(props.value) < 0 && 'fa' === 'fa' ? '-' : ''}
                                <TomansIcon/>
                            </> :
                            props.value
                    }
                </span>
                        </div>
                    </Link>
            }
        </div>
    );
};